import { useEffect } from "react";
import styles from './404-style.module.css';
import { Link } from "react-router-dom";

function PageNotFound({setShowNavBar}) {

    useEffect(() => setShowNavBar(false));

    console.log(window.location.pathname);

    return (
        <div id={styles._404_background}>
            <div id={styles._404_foreground}>
                <h1>404</h1>
                <h2>The page you are looking for does not seem to exist.</h2>
                <h3>If you were expecting something to be here (following a link, clicked a button, etc.), please let us know!</h3>
                <div id={styles.button_panel}>
                    <Link to='home'>Home</Link>
                    <Link to={`/contact?type=404&path=${window.location.pathname}`}>Contact Us</Link>
                </div>                
            </div>           
        </div>
    );
}

export default PageNotFound;